import drag from "./drag.js";

function install(Vue) {
  Vue.directive("drag", drag);
}

drag.install = install;

export default drag;
